import { useMemo } from 'react';
import { useSelector } from 'react-redux';
// @ts-expect-error no types
import { getNewFavouriteName } from '../../selectors/favoriteSelectors';
import { useParams } from 'react-router-dom';
import { useWatchLater } from '.';
import { useSearchParamCatalogSearch } from '../search';
export const useFavorites = () => {
  const {
    watchLaterItems,
    watchLaterLoading,
    watchLaterError
  } = useWatchLater();
  const hasFavorites = watchLaterItems !== null && watchLaterItems.length > 0;
  const {
    tracksLessonsSearchQueryData,
    tracksLessonsSearchQueryLoading,
    tracksLessonsSearchQueryError,
    searchQueryParams
  } = useSearchParamCatalogSearch();
  const favoritedItems = useMemo(() => watchLaterItems && tracksLessonsSearchQueryData ? watchLaterItems.filter(({
    contentId: watchLaterItemId,
    contentType: watchLaterItemType
  }) => {
    return tracksLessonsSearchQueryData.find(({
      id,
      contentType
    }) => Number(id) === watchLaterItemId && (contentType === 'SHORT_FORM_CONTENT' ? watchLaterItemType === 'SHORT_FORM_CONTENT' : contentType === 'TRACK' ? watchLaterItemType === 'TRACK' : watchLaterItemType !== 'TRACK'));
  }) : null, [tracksLessonsSearchQueryData, watchLaterItems]);
  return {
    hasFavorites,
    favoritedItems,
    favoritedItemsLoading: watchLaterLoading || tracksLessonsSearchQueryLoading,
    favoritedItemsError: watchLaterError || tracksLessonsSearchQueryError,
    searchQueryParams
  };
};
export const useFavoritesTooltip = () => {
  const {
    title,
    added
  } = useSelector(getNewFavouriteName);
  return {
    show: !!title,
    title,
    added
  };
};
export const useFavoritesParams = () => {
  const {
    page: pageParam
  } = useParams();
  return {
    page: Number(pageParam) || 1
  };
};